export const clubPickerSettings = {
  arrows: false,
  centerMode: false,
  dots: false,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 3.1,
  speed: 300,
  swipeToSlide: true
};
